import antdEnLocale from 'ant-design-vue/es/locale/en_US'
import antdZhCNLocale from 'ant-design-vue/es/locale/zh_CN'
import antdZhTWLocale from 'ant-design-vue/es/locale/zh_TW'

import 'dayjs/locale/en'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'

export enum LOCALE {
  'zh-cn' = 'zh-cn',
  'zh-tw' = 'zh-tw',
  'en' = 'en',
}
export interface IAntLocaleItem {
  name: LOCALE
  locale: any
}
export const ANT_LOCALE_LIST: IAntLocaleItem[] = [
  {
    name: LOCALE['zh-cn'],
    locale: antdZhCNLocale,
  },
  {
    name: LOCALE['zh-tw'],
    locale: antdZhTWLocale,
  },
  {
    name: LOCALE['en'],
    locale: antdEnLocale,
  },
]
export const DEFAULT_LOCALE = LOCALE['zh-cn']
